import {IntermediatePart} from "../../intermediatePart";

export default class TopCabinetShadow extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'top_cabinet_shadow';
    this.partName = 'Top Cabinet Shadow';
    this.visible = false;
    this.layerPriority = 6;
  }

  load(dbFeature) {
    const parts = dbFeature.metaData && dbFeature.metaData["Parts"];
    if (parts) {
      const partNumber = +dbFeature.metaData["Part"][0];
      return super.load_(dbFeature, new TopCabinetShadow(false, partNumber),
        true, partNumber === 1 ? 'features' : 'featuresParts');
    } else {
      return super.load_(dbFeature, new TopCabinetShadow());
    }
  }

  setLayers(layout) {

    const topCabinet = this.getParent().topCabinet;
    if (topCabinet && (topCabinet.disabled || !topCabinet.featureGroupEnabled)) {
      super.hideLayers();
      return
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      this.activeFeatureParts = this.setActiveFeatureParts();
      return super.setLayers(layout);
    }

    this.setDefault(layout);
    return super.setLayers(layout);
  }

  setActiveFeatureParts(fromFeature = this.activeFeature) {
    const activeFeatureParts = fromFeature && fromFeature.partNumber ? this.featuresParts.filter((feature) => {
      const name1 = fromFeature.partName.split(" Part")[0];
      // console.log("name1", name1);
      const name2 = feature.partName.split("Part2 ").join("");
      // console.log("name2", name2);
      return name1 === name2
    }) : [];
    activeFeatureParts.forEach((activeFeaturePart) => {
      activeFeaturePart.disabled = this.disabled
    });
    return activeFeatureParts
  }

  getArrayOfConditions() {
    const cabinetParent = this.getParent();
    return [{
      propName: "Appliance",
      propValue: cabinetParent.getTopCabinetApplianceType()
    }, {
      propName: 'CabinetLayout',
      propValue: cabinetParent.getTopCabinetShadowLayout()
    }, {
      propName: 'RoomLayout',
      propValue: cabinetParent.layout.getCurrentLayoutAbbreviation()
    }, {
      propName: 'CrownMolding',
      propValue: cabinetParent && cabinetParent.crownMolding &&
      cabinetParent.crownMolding.activeFeature && !cabinetParent.crownMolding.disabled ? "On" : "Off"
    }];
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Cabinet.TopCabinetShadow;
    }
    if (this.activeFeatureParts && this.activeFeatureParts.length) {
      this.activeFeatureParts.forEach((activeFeaturePart) => {
        activeFeaturePart.layer.zIndex = zIndexes.Cabinet.TopCabinetShadowPart2
      })
    }
  }
}
